import { useContext } from 'react';
import { RocheXXTranslationContext } from '../contexts/translation';
import { StringService } from '../services/string';

export function useTranslation(key: string, options: { capitalize?: boolean } = {}) {
  const translations = useContext(RocheXXTranslationContext);
  let t = translations[key] ?? key;
  if (options.capitalize && t.length > 0) {
    t = StringService.capitalize(t);
  }
  return t;
}
